export const duration = 2500
